import CreateMaterialStockLot from './CreateMaterialStockLot';
import DetailMaterialStock from './DetailMaterialStock';
import DetailMaterialStockLot from './DetailMaterialStockLot';
import DetailMaterialStockLotOfMaterial from './DetailMaterialStockLotOfMaterial';
import DetailMaterialTransaction from './DetailMaterialTransaction';
import EditMaterialCost from './EditMaterialCost';
import EditMaterialHistory from './EditMaterialHistory';
import EditMaterialStockLot from './EditMaterialStockLot';
import EditMaterialTransactionType from './EditMaterialTransactionType';
import ManyMaterialLots from './ManyMaterialLots';
import MaterialByGroupWithClickableTable from './MaterialByGroupWithClickableTable';
import MaterialChildLots from './MaterialChildLots';
import MaterialHistory from './MaterialHistory';
import MaterialStock from './MaterialStock';
import MaterialStockByGroup from './MaterialStockByGroup';
import MaterialStockLotList from './MaterialStockLotList';
import MaterialStockToProduct from './MaterialStockToProduct';
import MaterialTransactionType from './MaterialTransactionType';
import WithdrawMaterialStockLot from './WithdrawMaterialStockLot';

export {
  CreateMaterialStockLot,
  DetailMaterialStock,
  DetailMaterialStockLot,
  DetailMaterialStockLotOfMaterial,
  DetailMaterialTransaction,
  EditMaterialCost,
  EditMaterialHistory,
  EditMaterialStockLot,
  EditMaterialTransactionType,
  ManyMaterialLots,
  MaterialByGroupWithClickableTable,
  MaterialChildLots,
  MaterialHistory,
  MaterialStock,
  MaterialStockByGroup,
  MaterialStockLotList,
  MaterialStockToProduct,
  MaterialTransactionType,
  WithdrawMaterialStockLot,
};

export default {
  CreateMaterialStockLot,
  DetailMaterialStock,
  DetailMaterialStockLot,
  DetailMaterialStockLotOfMaterial,
  DetailMaterialTransaction,
  EditMaterialCost,
  EditMaterialHistory,
  EditMaterialStockLot,
  EditMaterialTransactionType,
  ManyMaterialLots,
  MaterialChildLots,
  MaterialHistory,
  MaterialStock,
  MaterialStockByGroup,
  MaterialStockLotList,
  MaterialStockToProduct,
  MaterialTransactionType,
  WithdrawMaterialStockLot,
  MaterialByGroupWithClickableTable,
};
